import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../../guards/auth-guard.service';
import {SingleReservationComponent} from './single-reservation.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.singleReservation.pageInRouting,
    data: {data: PAGES_AND_PATHS.singleReservation},
    component: SingleReservationComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./single-reservation.module').then(m => m.SingleReservationModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SingleReservationRoutingModule { }
